import React from 'react';
import './Footer.scss';

const Footer = () => {
    const year = (new Date()).getFullYear();
    return <div className='footerContainer clearfix'>
        <div className='float-start'>
            Copyright &copy; {year} Toyoto - All Rights Reserved
        </div>
        <div className='float-end'>
            <a href='/'>Privacy Policy</a>
            <a href='/'>Terms of Use</a>
        </div>
    </div>
}

export default Footer;